import React from 'react';
import { connect } from "react-redux";
import {
    TextField, PrimaryButton, Dialog, DatePicker,
    ChoiceGroup, DialogFooter, DefaultButton, Spinner, SpinnerSize
} from 'office-ui-fabric-react';
import {
    PATIENT_ASSIGNMENT_LIST, LEAD_CATEGORY_LIST
} from "../../constants/lists";
import { LEAD_CATEGORY } from "../../constants/enums";
import { browserHistory } from "react-router";


import moment from "moment";
import axios from "axios";
import config from "../../config";

export class AssignCategoryForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showDialog: this.props.showDialog,
            showComments: false,
            showReminderDate: false,
            showSequentialLeadNumber: false,
            selected: this.props.selected || "",
            isUpdating: false,
            sequentialLeadNumber: "",
            patientAssignment: this.props.rowSelected.patientAssignment || "",
            isCloserPage: this.props.isCloserPage || false

        }

        this.rowSelected = this.props.rowSelected;

        this.close = this.close.bind(this);
        this.save = this.save.bind(this);

    }


    close() {
        this.props.assignCategoryCallback(
            {
                showCatDialog: false,

            }
        );

        this.state.selected = null;
    }

    change(e) {
        switch (e.key) {
            case LEAD_CATEGORY.IN_PROCESS:
                this.setState({
                    showComments: true,
                    showSequentialLeadNumber: false,
                    showReminderDate: true,
                    selected: e.key 
                });
                break;
            case LEAD_CATEGORY.NO_ANSWER:
                this.setState({
                    showComments: false,
                    showReminderDate: true,
                    showSequentialLeadNumber: false,
                    selected: e.key 
                });
                break;
            case LEAD_CATEGORY.LEAD:
                this.setState({
                    showComments: false,
                    showReminderDate: false,
                    showSequentialLeadNumber: true,
                    selected: e.key 
                });

                break;

            default:
                this.setState({
                    showComments: false,
                    showReminderDate: false,
                    showSequentialLeadNumber: false,
                    selected: e.key 
                });
        }

    }


    changePA(opt) {
        if (!this.state.sequentialLeadNumber) {
            axios
                .get(`${config.apiUrl}/customer/generate-seq-no`)
                .then(({ data }) => {
                    this.setState({ sequentialLeadNumber: data.number });
                })
                .catch(() => this.props.assignCategoryCallback(
                    { sequentialLeadNumber: "#ERROR#" }
                ));
        }

        this.setState({ patientAssignment: opt.key });

        this.rowSelected.processResults = opt.key;

    }


    save() {

        const oldProcess = this.rowSelected.processResults;
        this.rowSelected.processResults =
            this.state.selected !== null ? this.state.selected : "LE";


        if ("IP" === this.state.selected) {
            this.rowSelected.comments = this.refs.comments.value;
        }
        if ("IP" === this.state.selected || "NA" === this.state.selected) {
            this.rowSelected.reminderDate = this.refs.reminderDate.state.selectedDate.toISOString();
        }
        if ("LE" === this.state.selected) {
            this.rowSelected.patientAssignment = this.state.patientAssignment;
            this.rowSelected.sequentialLeadNumber = this.state.sequentialLeadNumber;
        }

        const idx = this.rowSelected._id;
        let moveToLeadScreen = false;

        if (this.rowSelected.processResults === "LE") {
            if (oldProcess === "LE") {
                this.rowSelected.comments = this.rowSelected.comments || "";
            } else {
                this.rowSelected.comments = "";
            }
            this.rowSelected.reminderDate = null;
            moveToLeadScreen = true;
        }
        if (!this.props.isCloserPage) {
            this.rowSelected.staffAssignedId = this.props.auth.user._id;
            this.rowSelected.staffAssigned = this.props.auth.user;
        }

        this.setState({
            isUpdating: true,
        });

        axios
            .post(`${config.apiUrl}/customer/update`, this.rowSelected)
            .then(({ data }) => {

                this.rowSelected = null;
                this.state.selected = null;
                this.setState({
                    isUpdating: false,
                });

                

                /*this.props.assignCategoryCallback(
                    {
                        showCatDialog: false,

                    }
                );*/

                if (moveToLeadScreen && !this.state.isCloserPage) {
                    //browserHistory.push(`/lead?id=${idx}`);
                    this.props.assignCategoryCallback(
                        {
                            showCatDialog: false,
    
                        }
                    );
                    window.location.href = `/lead?id=${idx}`;
                }else{

                    this.props.refreshCustomerList(data);
                }
            })
            .catch((ex) => {
                console.error(ex);
                this.setState({
                    isUpdating: false,
                });
                this.props.assignCategoryCallback(
                    {
                        showCatDialog: false,

                    }
                );
                alert("Error");
            });

    }

    render() {

        return (<div>
            {
                <Dialog
                    isOpen={this.state.showDialog}
                    title={`${this.rowSelected && this.rowSelected.firstName} ${this.rowSelected && this.rowSelected.lastName
                        } | ${this.rowSelected && this.rowSelected.phone
                        } | Assign a category`}
                    isBlocking={false}
                    closeButtonAriaLabel="Close"
                    containerClassName="info-list-modal"
                    onDismiss={this.close}
                >
                    {this.rowSelected && (
                        <div className="ms-Grid">
                            <div className="ms-Grid-col ms-u-md6">
                                <ChoiceGroup
                                    defaultSelectedKey={this.rowSelected.processResults || ""}
                                    options={LEAD_CATEGORY_LIST.filter(
                                        (opt) =>
                                            ![LEAD_CATEGORY.ALL, LEAD_CATEGORY.EMPTY].includes(
                                                opt.key
                                            ) && (this.state.isCloserPage && opt.key!==LEAD_CATEGORY.LEAD
                                                || !this.state.isCloserPage)
                                    )}
                                    onChange={(_, newValue) => this.change(newValue)}
                                />
                            </div>
                            <div
                                className="ms-Grid-col ms-u-md6"
                                style={{ borderLeft: "1px solid lightgray" }}
                            >
                                {!this.state.isCloserPage && this.state.selected === LEAD_CATEGORY.LEAD && (
                                    <ChoiceGroup
                                        options={PATIENT_ASSIGNMENT_LIST}
                                        selectedKey={this.state.patientAssignment}
                                        onChange={(_, newValue) => this.changePA(newValue)}
                                    />
                                )}
                            </div>
                            <div
                                className="ms-Grid-col ms-u-md12"
                                style={{ marginTop: 10, borderTop: "1px solid lightgray" }}
                            >
                                {this.state.showSequentialLeadNumber && (
                                    <div className="ms-Grid-col ms-u-md6">
                                        <TextField
                                            ref="sequentialLeadNumber"
                                            label="Sequential Lead Number"
                                            value={this.rowSelected.seqNumber}
                                            disabled
                                        />
                                    </div>
                                )}
                                {this.state.showComments && (
                                    <div className="ms-Grid-col ms-u-md6">
                                        <TextField
                                            ref="comments"
                                            label="Comments"
                                            defaultValue={this.rowSelected.comments}
                                        />
                                    </div>
                                )}
                                {this.state.showReminderDate && (
                                    <div className="ms-Grid-col ms-u-md6">
                                        <DatePicker
                                            ref="reminderDate"
                                            label="Reminder date"
                                            formatDate={(date) => moment(date).format("MMM DD YYYY")}
                                            value={
                                                this.rowSelected.reminderDate
                                                    ? new Date(this.rowSelected.reminderDate)
                                                    : new Date()
                                            }
                                            allowTextInput
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                    <DialogFooter>
                        {this.state.isUpdating ? (
                            <Spinner key={2} size={SpinnerSize.large} />
                        ) : (
                            [
                                <PrimaryButton
                                    key="ok"
                                    onClick={() => this.save()}
                                    disabled={
                                        this.state.selected === "LE" && !this.state.sequentialLeadNumber
                                    }
                                >
                                    Save
                                </PrimaryButton>,
                                <DefaultButton key="cancel" onClick={() => this.close()}>
                                    Cancel
                                </DefaultButton>,
                            ]
                        )}
                    </DialogFooter>
                </Dialog>
            }
        </div>
        );
    }
}

function mapStateToProps(state, own_props) {
    return {
        auth: state.auth
    }
}

export default connect(mapStateToProps)(AssignCategoryForm);


// WEBPACK FOOTER //
// ./client/components/common/AssignCategoryForm.js